import { BREAKPOINTS } from "@/settings";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import { PageHeader } from "../../components/molecules/PageHeader/PageHeader";
import { ChemistryProfiles } from "../../functions/calculateChemistry";
import {
  fetchChemistryProfiles,
  loadedContentSelector,
} from "../../redux/loadedContent/loadedContentSlice";
import { loadChemistryProfiles as loadChemistryProfilesDefaultSquadBuilder } from "../../redux/squadBuilder/defaultSquadBuilder/defaultSquadBuilderSlice";
import { AppDispatch } from "../../redux/store";
import { getUserSelector } from "../../redux/user/userSlice";
import { DefaultSquadBuilder } from "./Default/DefaultSquadBuilder";

const SquadBuilder = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { formationsStatus, chemistryProfilesStatus } = useSelector(
    loadedContentSelector,
  );
  const { user } = useSelector(getUserSelector);
  const desktopMode = !useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  const tabletOrLargerMode = !useMediaQuery(BREAKPOINTS.MOBILE.query);

  useEffect(() => {
    if (chemistryProfilesStatus === "idle") {
      dispatch(fetchChemistryProfiles()).then((res) => {
        dispatch(
          loadChemistryProfilesDefaultSquadBuilder(
            res.payload as ChemistryProfiles,
          ),
        );
      });
    }
  }, [dispatch, formationsStatus, chemistryProfilesStatus]);

  return (
    <>
      <PageHeader
        title={"EA FC 25 Squad Builder"}
        isMobile={!tabletOrLargerMode}
        maxWidth={"max-w-[2000px]"}
        color="bg-[#1B3142]"
        helmetTitle={"EA FC 25 Squad Builder - EasySBC"}
        helmetContent="World's only AI Squad Builder for EA FC 25. Build the most meta squads with high chemistry around your favorite players and within your budget in seconds."
        helmetLink="https://www.easysbc.io/squad-builder"
      />
      <DefaultSquadBuilder
        user={user}
        desktopMode={desktopMode}
        tabletOrLargerMode={tabletOrLargerMode}
      />
    </>
  );
};

export default SquadBuilder;
